// extracted by mini-css-extract-plugin
module.exports = {"singlePipeline":"SinglePipeline_singlePipeline__2f4IQ","changeButton":"SinglePipeline_changeButton__pqwL_"};